import styled from "styled-components";
import {
  FlexContainer,
  FlexSection,
  FlexDiv,
  Button,
} from "../../../components/Atoms";
import Card from "@/components/Atoms/Card";
import Avatar from "@/components/Molecules/Avatar";

export const StyledCard = styled(Card)`
  flex-direction: column;
  max-width: calc(33.33% - 16px);
  @media only screen and (max-width: 992px) {
    max-width: calc(50% - 16px);
  }
  @media only screen and (max-width: 767px) {
    max-width: 100%;
  }
`;

export const StyledAvatar = styled(Avatar)`
  max-width: calc(33.33% - 16px);
  flex-direction: column;
`;

export const Wrapper = styled(FlexSection)`
  padding: 40px 0 32px;
  position: relative;
  > div {
    justify-content: center;
    position: relative;
    z-index: 1;
  }
  &:before {
    z-index: 0;
    content: "";
    height: 30%;
    max-height: 250px;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: ${({ theme }) => theme.colorsV2.shyft.cream};
  }
  @media only screen and (max-width: 767px) {
    padding: 32px 0 32px;
  }
`;

export const Container = styled(FlexContainer)`
  @media only screen and (max-width: 767px) {
    padding: 0;
  }
`;

export const Div = styled(FlexDiv)``;

export const TextBox = styled(FlexDiv)`
  padding: 24px 48px 16px;
  flex-direction: column;
`;

export const ListDiv = styled(FlexDiv)`
  margin: 0 -8px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: flex-start;
  @media only screen and (max-width: 767px) {
    margin: 0;
    padding: 0;
  }
`;

export const EmptyCard = styled(StyledCard)`
  background-color: ${({ theme }) => theme.colorsV2.rose.shade_50};
  padding: 48px 40px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border: 1px solid ${({ theme }) => theme.colorsV2.gray.shade_200};
  @media only screen and (max-width: 767px) {
    margin: 8px 0 0 0;
    border-radius: 0;
    border: 0;
    box-shadow: none;
  }
`;

export const StyledCta = styled(Button)``;

export const ImageBanner = styled(FlexDiv)`
  max-width: 100%;
  min-height: 184px;
  max-height: 184px;
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.colorsV2.gray.shade_300};
  img {
    height: 100%;
    max-height: 100%;
    object-fit: cover;
    width: 100%;
  }
`;

export const ImageList = styled(FlexDiv)`
  margin: 0 -8px 16px;
  flex-wrap: wrap;
  justify-content: center;
`;
